<section class="map-container">
  <div class="container">
    <div class="map-header">
      <h2>Se hvilke områder der bruger DUNA</h2>
      <p>
        Opdag de regioner i Danmark, der allerede nyder godt af DUNA platformen. 
        Hold musen over de forskellige regioner for at se detaljerede oplysninger.
      </p>
      
      <div class="legend">
        <div class="legend-item">
          <div class="legend-color duna"></div>
          <span>Bruger DUNA</span>
        </div>
        <div class="legend-item">
          <div class="legend-color non-duna"></div>
          <span>Bruger ikke DUNA</span>
        </div>
      </div>
    </div>

    <div class="map-wrapper">
      <div id="svgContainer">
        <div class="loading-message">
          Indlæser interaktivt kort...
        </div>
      </div>
    </div>

    <div class="map-cta">
      <h3>Vil du vide mere om DUNA?</h3>
      <p>
        Kontakt os for at høre mere om, hvordan DUNA kan hjælpe jeres brandvæsen 
        med moderne uddannelse og træning.
      </p>
      <a routerLink="/kontakt" class="cta-button">
        Kontakt os
        <i class="material-icons icon">arrow_forward</i>
      </a>
    </div>
  </div>

  <!-- Tooltip element -->
  <div id="tooltip"></div>
</section>
